import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim',
  standalone: false
})
export class TrimPipe implements PipeTransform {

  transform(value: string, limit: number = 33): string {
    if (typeof value !== 'string') {
      return value;
    }
    if (value.length > limit) {
      return value.substring(0, limit) + '...';
    }
    return value;
  }
}
